<template>
  <div v-if="sections.length">
    <div
      class="decorated-destacados pt-4 text-27-security font-weight-bold"
      style="letter-spacing: 1.5px; color: #180e4a"
    >
      <span>DESTACADOS</span>
    </div>
    <v-layout row wrap pt-4>
      <v-flex xs12 md6 :class="{'pr-2': $vuetify.breakpoint.smAndUp}" v-if="section1">
        <ProtagonistsCarousel></ProtagonistsCarousel>
      </v-flex>

      <v-flex md6 xs12 :class="{'pl-2': $vuetify.breakpoint.smAndUp}" v-if="section2">
        <a :href="section2.url" :target="section2.is_blank">
          <SectionsCardA :section_image="section2.image" />
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SectionsCardA from './SectionsCardA';
import ProtagonistsCarousel from './ProtagonistsCarousel.vue'


export default {
  components: {
    SectionsCardA,
    ProtagonistsCarousel
  },
  data: () => ({
    sections: []
  }),
  methods: {
    ...mapActions("sections", ["fetchSections"]),
    sectionToPost(slug) {
      this.$router.push({
        name: "post-show",
        params: { slug: slug }
      })
    },
    getSection(position) {
      return this.sections.find( section => section.position == position)
    },
    async getSections() {
      const res = await this.fetchSections()
      this.sections = res
    }
  },
  computed: {
    section1() {
      return this.getSection(4);
    },
    section2() {
      return this.getSection(5);
    },
  },
  created() {
    this.getSections()
  },
};
</script>

<style>
.decorated-destacados {
  overflow: hidden;
  text-align: center;
}
.decorated-destacados > span {
  position: relative;
  display: inline-block;
}
.decorated-destacados > span:before,
.decorated-destacados > span:after {
  content: "";
  position: absolute;
  top: 50%;
  border-bottom: 1px solid;
  width: 290%; /* half of limiter*/
  margin: 0 72px;
}
.decorated-destacados > span:before {
  right: 100%;
}
.decorated-destacados > span:after {
  left: 100%;
}
</style>